import { useCallback, useState } from 'react';

export function useScreenToggles() {

    // Controls which optional screens/forms are visible
    const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);
    const [showUploadPdf, setShowUploadPdf] = useState(false);
    const [showAdmin, setShowAdmin] = useState(false);
    const [showNewsletterQnA, setShowNewsletterQnA] = useState(false);

    const toggleSubscriptionForm = useCallback(() => {
        setShowSubscriptionForm(prev => !prev);
    }, []);

    const toggleUploadPdf = useCallback(() => {
        setShowUploadPdf(prev => !prev);
    }, []);

    const toggleAdminScreen = useCallback(() => {
        setShowAdmin(prev => !prev);
    }, []);

    const toggleNewsletterQnA = useCallback(() => {
        setShowNewsletterQnA(prev => !prev);
    }, []);

    return {
        showSubscriptionForm,
        showUploadPdf,
        showAdmin,
        showNewsletterQnA,
        toggleSubscriptionForm,
        toggleUploadPdf,
        toggleAdminScreen,
        toggleNewsletterQnA,
        setShowAdmin,
    };
}